var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agendamento.dataPrimeiroDiagnostico)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"custom-tooltip",attrs:{"data-cy":("primeiroDiagnostico-" + (_vm.agendamento.id))}},on),[_c('strong',[_vm._v("1T")])])]}}],null,false,3260170527)},[_c('span',[_vm._v("1º Tratamento")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }